import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useNavigate } from '@lib/react-router-dom'

import { BecomeIBModal } from '@pages/IntroducingBroker/SignUp/Type/modals/BecomeIB.modal'

import { useModal } from '@context/ModalsContext'

import { Heading6 } from '@ui/Typography'

import { useGAEvents } from '@utils/callGAEvents'

import { IBTestSubCategory } from '@model/TestSectionsDto'

import { IBCarousel } from '../Carousel/IBCarousel'
import { IBSignUpForm } from './IBSignUpForm'
import { EarnRewardsModal } from './modals/EarnRewards.modal'

import styles from './IBSignUpTypePage.module.scss'

interface Props {
  isProfile?: boolean
}

export const IBSignUpTypePage: React.FC<Props> = ({ isProfile }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { callGAEvents } = useGAEvents()
  const [subCategoryId, setSubCategoryId] = useState<IBTestSubCategory>()

  const becomeIBInfoModal = useModal(BecomeIBModal)
  const earnRewardsInfoModal = useModal(EarnRewardsModal)

  const signUpNextStep = async () => {
    callGAEvents().IBQuestionnaire.Actions.submit()
    if (isProfile) {
      navigate(`/profile/introducing-broker/register/${subCategoryId}/questionnaire`)
    } else {
      navigate(`/dashboard/introducing-broker/register/${subCategoryId}/questionnaire`, {
        state: { fromSignUp: true },
      })
    }
  }

  const handleWhyBecomeIBClick = () => {
    callGAEvents().IBQuestionnaire.InfoLinks.whyBecomeIB()
    if (!becomeIBInfoModal.isOpen) {
      becomeIBInfoModal.open()
    }
  }

  const handleLoyaltyProgramClick = () => {
    callGAEvents().IBQuestionnaire.InfoLinks.loyaltyProgram()
    if (!earnRewardsInfoModal.isOpen) {
      earnRewardsInfoModal.open()
    }
  }

  return (
    <>
      <div className={styles.formInputWrapper}>
        <Heading6 medium>{t('IB.Register')}</Heading6>
        <p className='is-link' onClick={handleWhyBecomeIBClick}>
          {t('IB.Why should I become an IB?')}
        </p>
        <p className='is-link' onClick={handleLoyaltyProgramClick}>
          {t('IB.Earn additional rewards with our IB Loyalty Program')}
        </p>
        <IBSignUpForm
          subCategoryId={subCategoryId}
          setSubCategoryId={setSubCategoryId}
          handleSignUp={signUpNextStep}
        />
      </div>
      <IBCarousel subCategoryId={subCategoryId} />
    </>
  )
}
